@if (!registrationChecked && !registrationCompleted) {
    <!-- STEP 1 -->
    <div class="yellowMask">
        <div class="headerContainer">
            <div id="headerLogo" class="linkLogo" (click)="gotoLogin()" title="Zur Anmeldeseite"></div>
            <button class="headerButton btn-yellow-white" (click)="fwHilfe()">
                <span class="hilfe"></span>
            </button>
            <button class="headerButton btn-yellow-white" (click)="fwKautionsPage()">
                <span>Zur Kautions-Produktseite</span>
            </button>
        </div>
        <div class="contentContainer">
            <h1>Verifizierung</h1>
            <div class="gridContainer formGrid loginGrid">
                <div class="row">
                    <div class="cell grid-100">Bitte geben Sie hier die Zugangsdaten ein, die Sie in zwei Briefen erhalten haben.</div>
                </div>
                <div class="row">
                    <div class="cell grid-100">
                        <input type="text"
                               id="loginName"
                               aria-label="Benutzername"
                               placeholder="Benutzername"
                               class="loginInput"
                               [(ngModel)]="model.loginName.value"
                               [class.error]="model.loginName.valid === false"
                               (keyup)="onCheckRegFieldKeyUp($event)">
                        @if (model.loginName.valid === false) {
                            <div
                                class="errorMessage"
                                [innerHTML]="model.loginName.errorMsg"></div>
                        }
                    </div>
                </div>
                <div class="row">
                    <div class="cell grid-100">
                        <input type="password"
                               id="loginPIN"
                               aria-label="Passwort"
                               placeholder="Passwort"
                               class="loginInput"
                               [(ngModel)]="model.loginPIN.value"
                               [class.error]="model.loginPIN.valid === false"
                               (keyup)="onCheckRegFieldKeyUp($event)">
                        @if (model.loginPIN.valid === false) {
                            <div
                                class="errorMessage"
                                [innerHTML]="model.loginPIN.errorMsg"></div>
                        }
                    </div>
                </div>
                <div class="row">
                    <div class="cell grid-100">
                        <elem-button buttonRole="PRIMARY" class="expand register-btn" [disabled]="regCheckBtnLocked" (click)="checkRegistration()">
                            Jetzt verifizieren
                        </elem-button>
                    </div>
                </div>
            </div>
        </div>
        <extern-footer class="pageYellow"></extern-footer>
    </div>
} @else if (registrationChecked && !registrationCompleted) {
    <!-- STEP 2 -->
    <div class="previewLayout">
        <div class="content-wrapper">
            <div id="header">
                <div id="headerLogo" (click)="gotoLogin()" title="Zur Anmeldeseite"></div>
            </div>
            <div class="mainContainer">
                <div class="menu">
                    @if (hilfeMenupoint) {
                        <elem-menupoint
                            [active]="true"
                            [menupoint]="hilfeMenupoint"
                            [hidden]="hilfeMenupoint.hidden"
                            [first]="true"></elem-menupoint>
                    }
                </div>
                <div class="content">
                    <h1>Verifizierung erfolgreich.</h1>
                    <h2>
                        Um die Registrierung abzuschließen, ergänzen Sie bitte folgende Daten:
                        <div class="options">
                            <span class="hinweis">* Pflichtfelder</span>
                        </div>
                    </h2>
                    <div class="gridContainer formGrid fitGrid">
                        @if (error) {
                            <div class="error">Leider ist etwas schiefgelaufen. Bitte laden Sie die Seite neu oder versuchen Sie es erneut.</div>
                        }
                        <div class="row">
                            <div class="cell grid-25">
                                <label class="field-label" for="vorname">Vorname *</label>
                            </div>
                            <div class="cell grid-50">
                                <input type="text"
                                       id="vorname"
                                       placeholder="Vorname"
                                       [(ngModel)]="model.vorname.value"
                                       (blur)="validateField(model.vorname)"
                                       [class.error]="model.vorname.valid === false"
                                       (keyup)="onCompleteRegFieldKeyUp($event)">
                                @if (model.vorname.valid === false) {
                                    <div
                                        class="errorMessage"
                                        [innerHTML]="model.vorname.errorMsg"></div>
                                }
                            </div>
                            <div class="cell grid-25"></div>
                        </div>
                        <div class="row trenner"></div>
                        <div class="row">
                            <div class="cell grid-25">
                                <label class="field-label" for="nachname">Name *</label>
                            </div>
                            <div class="cell grid-50">
                                <input type="text"
                                       id="nachname"
                                       placeholder="Nachname"
                                       [(ngModel)]="model.nachname.value"
                                       (blur)="validateField(model.nachname)"
                                       [class.error]="model.nachname.valid === false"
                                       (keyup)="onCompleteRegFieldKeyUp($event)">
                                @if (model.nachname.valid === false) {
                                    <div
                                        class="errorMessage"
                                        [innerHTML]="model.nachname.errorMsg"></div>
                                }
                            </div>
                            <div class="cell grid-25"></div>
                        </div>
                        <div class="row trenner"></div>
                        <div class="row">
                            <div class="cell grid-25">
                                <label class="field-label" for="password">Passwort *</label>
                            </div>
                            <div class="cell grid-25">
                                <input type="password"
                                       id="password"
                                       placeholder="Passwort"
                                       [(ngModel)]="model.password.value"
                                       (blur)="validatePassword(model.password)"
                                       [class.error]="model.password.valid === false"
                                       (keyup)="onCompleteRegFieldKeyUp($event)">
                                @if (model.password.valid === false) {
                                    <div
                                        class="errorMessage"
                                        [innerHTML]="model.password.errorMsg"></div>
                                }
                            </div>
                            <div class="cell grid-50"></div>
                        </div>
                        <div class="row">
                            <div class="cell grid-25">
                                <label class="field-label" for="password_confirm">Passwort wiederholen *</label>
                            </div>
                            <div class="cell grid-25">
                                <input type="password"
                                       id="password_confirm"
                                       placeholder="Passwort wiederholen"
                                       [(ngModel)]="model.passwordConfirm"
                                       (blur)="validateField(model.password)"
                                       [class.error]="model.password.valid === false"
                                       (keyup)="onCompleteRegFieldKeyUp($event)">
                                @if (model.password.valid === false) {
                                    <div
                                        class="errorMessage"
                                        [innerHTML]="model.password.errorMsg"></div>
                                }
                            </div>
                            <div class="cell grid-50"></div>
                        </div>
                        <div class="row">
                            <div class="cell grid-25"></div>
                            <div class="cell grid-50">
                                <div>Das Passwort muss folgende Voraussetzungen erfüllen:</div>
                                <div class="pwChecklist">
                                    <div [class.fulfilled]="pwCorrectNumChars">mind. 12 bis max. 40 Zeichen</div>
                                    <div [class.fulfilled]="pwCorrectMajuscule">mind. ein Großbuchstabe</div>
                                    <div [class.fulfilled]="pwCorrectMinuscule">mind. ein Kleinbuchstabe</div>
                                    <div [class.fulfilled]="pwCorrectDigit">mind. eine Ziffer</div>
                                    <div [class.fulfilled]="pwCorrectSpecialChar">mind. eins der Sonderzeichen <span style="font-family: monospace">!?&#64;()&lcub;&rcub;[]\/=~$%&amp;#*-+.,_</span></div>
                                    <div class="violation" [hidden]="!model.password.value || pwCheckNoOtherChars">Das Passwort enthält nicht erlaubte Zeichen, zugelassen sind nur die zuvor aufgeführten Zeichen</div>
                                    <div [class.fulfilled]="pwCorrectPasswordConfirm">Passwort und Wiederholung stimmen überein</div>
                                </div>
                            </div>
                            <div class="cell grid-25"></div>
                        </div>
                        <div class="row trenner"></div>
                        <div class="row">
                            <div class="cell grid-25">
                                <label class="field-label" for="email">E-Mail-Adresse *</label>
                            </div>
                            <div class="cell grid-25">
                                <input type="text"
                                       id="email"
                                       placeholder="E-Mail-Adresse"
                                       [(ngModel)]="model.email.value"
                                       (blur)="validateEmail(model.email)"
                                       [class.error]="model.email.valid === false"
                                       (keyup)="onCompleteRegFieldKeyUp($event)">
                                @if (model.email.valid === false) {
                                    <div
                                        class="errorMessage"
                                        [innerHTML]="model.email.errorMsg"></div>
                                }
                            </div>
                            <div class="cell grid-50"></div>
                        </div>
                        <div class="row">
                            <div class="cell grid-25">
                                <label class="field-label" for="email_confirm">E-Mail-Adresse wiederholen *</label>
                            </div>
                            <div class="cell grid-25">
                                <input type="text"
                                       id="email_confirm"
                                       placeholder="E-Mail-Adresse wiederholen"
                                       [(ngModel)]="model.emailConfirm"
                                       (blur)="validateField(model.email)"
                                       [class.error]="model.email.valid === false"
                                       (keyup)="onCompleteRegFieldKeyUp($event)">
                                @if (model.email.valid === false) {
                                    <div
                                        class="errorMessage"
                                        [innerHTML]="model.email.errorMsg"></div>
                                }
                            </div>
                            <div class="cell grid-50"></div>
                        </div>
                        <div class="row trenner"></div>
                        <div class="row">
                            <div class="cell grid-75"></div>
                            <div class="cell grid-25">
                                <elem-button buttonRole="PRIMARY" class="expand" [disabled]="regCompleteBtnLocked" (click)="completeRegistration()">
                                    Registrierung abschließen
                                </elem-button>
                            </div>
                        </div>
                    </div>
                    <extern-footer class="pagePreview"></extern-footer>
                </div>
            </div>
        </div>
    </div>
} @else if (registrationChecked && registrationCompleted) {
    <!-- STEP 3 -->
    <div class="previewLayout">
        <div class="content-wrapper">
            <div id="header">
                <div id="headerLogo" (click)="gotoLogin()" title="Zur Anmeldeseite"></div>
            </div>
            <div class="mainContainer">
                <div class="menu">
                    @if (hilfeMenupoint) {
                        <elem-menupoint
                            [active]="false"
                            [menupoint]="hilfeMenupoint"
                            [hidden]="hilfeMenupoint.hidden"
                            [first]="true"></elem-menupoint>
                    }
                </div>
                <div class="content">
                    <h1>Registrierung abgeschlossen.</h1>
                    <h2>Sie erhalten in wenigen Minuten eine Best&auml;tigungs-E-Mail.</h2>
                    <ol>
                        <li>Klicken Sie den darin enthaltenen Link an.</li>
                        <li>Sie k&ouml;nnen das Kreditportal sofort nutzen.</li>
                    </ol>
                    <p>Sollten Sie keine Best&auml;tigungsemail erhalten, überprüfen Sie bitte Ihren Spam-Ordner.</p>
                    <p>Bei Problemen mit der Registrierung wenden Sie sich einfach an unsere Kundenhotline unter 0511 / 907 4260.</p>
                    <extern-footer class="pagePreview"></extern-footer>
                </div>
            </div>
        </div>
    </div>
}
